import { Message } from 'element-ui';

// 当前提示未关闭则不再弹出
export const msg = {
  success: function(msg, callBack) {
    if (!window.showMessage) {
      window.showMessage = true;
      Message.success(msg, function() {
        window.showMessage = false;
        callBack();
      });
    }
  },
  warning: function(msg) {
    if (!window.showMessage) {
      window.showMessage = true;
      Message.warning(msg, function() {
        window.showMessage = false;
        callBack();
      });
    }
  },
  error: function(msg) {
    if (!window.showMessage) {
      window.showMessage = true;
      Message.error(msg, function() {
        window.showMessage = false;
        callBack();
      });
    }
  }
}

// 获取当前环境
export const getEnv = () => {
  const topHost = window.location.host.split('.')[0]
  if (topHost.indexOf('localhost') != -1) {
    return 'test'
  }
  if (topHost.indexOf('pre') != -1) {
    return 'pre'
  } else if (topHost.indexOf('test') != -1){
    return 'test'
  }
  const secHost = window.location.href.split('.')[1]
  if (secHost && secHost.indexOf('pre') != -1) {
    return 'pre'
  } else if (secHost && secHost.indexOf('test') != -1){
    return 'test'
  }
  return 'rel'
};


/**
 * 设置cookie
 *
 * @param key 名称
 * @param value 内容
 * @param options 其它参数(expires, domain, path, secure)
 * @returns cookie的值 或者是设置cookie
 */

export const cookie = {
  set: (key, val, options) => {
    options = options || {};
    if (val === null) {
      val = '';
        options.expires = -1;
    }
    var expires = '';
    if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
      var date;
      if (typeof options.expires == 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString();
    }
    var path = options.path ? '; path=' + options.path : '';
    var domain = options.domain ? '; domain=' + options.domain : '';
    var secure = options.secure ? '; secure' : '';
    if (typeof(val) !== 'string') {
      val = JSON.stringify(val)
    }
    document.cookie = [key, '=', encodeURIComponent(val), expires, path, domain, secure].join('');
  },
  get: (key) => {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].replace(/^\s+|\s+$/g,'');
        if (cookie.substring(0, key.length + 1) == (key + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(key.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }
}

/*
 * 主域名
 * */
export const mainHost = () => {
  return window.location.host.split('.').slice(-2).join('.')
};


/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
export const hasPermission = (roles, route) => {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role));
  } else {
    return true;
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
export const filterAsyncRouter = (routes, roles) => {
  const res = [];

  routes.forEach(route => {
    const tmp = { ...route };
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  return res;
}

/*
 * 验证 http链接
 * */
export const urlTest = (url) => {
  if (url.toString().indexOf('http://') < 0 && url.toString().indexOf('https://') < 0) {
    url = 'http://' + url;
  }
  const reg = /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
  if (reg.test(url)) {
    return url;
  } else{
    return -1;
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js